// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-grid-list__item--brochure img{margin-left:auto;margin-right:auto}.czt-grid-list__item--brochure .czt-link{display:block;font-weight:bold;transition:300ms opacity}.czt-grid-list__item--brochure .czt-link:hover{opacity:.8}.czt-grid-list__item__brochure-title{padding-top:15px;padding-bottom:20px}", ""]);
// Exports
module.exports = exports;
